const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/registrationStatus.ts';
import Imm from 'immutable';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { decCounter, incCounter } from '@cistec/common_web/utils/reducerUtils';
import { IKISAPIAction, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { REQUEST_ACTION_TYPES_CHECK_REGISTRATION_STATUS } from 'App/actions/registrationStatus';

const Log = Logger('checkRegristrationStatusReducer');

const initialState = Imm.fromJS({
    loading: 0,

    records: {
        // Maps workId -> record
    },
});

export function registrationStatus(state: ReducerState = initialState, action: any = {}) {
    switch (action.type) {
        case REQUEST_ACTION_TYPES_CHECK_REGISTRATION_STATUS.pending:
            return checkRegristrationStatusPending(state);
        case REQUEST_ACTION_TYPES_CHECK_REGISTRATION_STATUS.success:
            return checkRegristrationStatusSuccess(state, action);
        case REQUEST_ACTION_TYPES_CHECK_REGISTRATION_STATUS.failure:
            return checkRegristrationStatusFailure(state, action);
    }

    return state;
}

function checkRegristrationStatusPending(state: ReducerState) {
    return incCounter(state, ['loading']);
}

function checkRegristrationStatusSuccess(state: ReducerState, action: IKISAPIAction) {
    const list = Imm.fromJS(action?.payload || {});
    state = state.setIn(['records'], list);

    return decCounter(state, ['loading']);
}

function checkRegristrationStatusFailure(state: ReducerState, action: IKISAPIAction) {
    Log.warn(`Failed to load entries: ${action.payload.returnedValue.details.Info}`);
    return decCounter(state, ['loading']);
}
